<template>
  <Panel
    :class="'panel-appearance-panel'"
    :variant="['30-paddings', 'default', 'rounded']"
  >
    <Subheader
      :text="$$t('Appearance')"
      class="tournament-info-wrapper__title mb-5"
    />
    <div class="row mb-5">
      <div class="col-6 vanity-name">
        <TournamentTitleSetting class="tournament-name" />
        <TournamentSettingVanityId />
        <TournamentDescriptionSetting class="tournament-description" />
      </div>
      <div class="col-4 tournament-cover ml-4">
        <TournamentCoverSetting />
      </div>
      <div class="col-2 tournament-portrait" style="max-width: 186px;">
        <TournamentSettingPortraitCover />
      </div>
    </div>
    <div class="row">
      <div class="col-4 tournament-stream">
        <TournamentSettingStreamUrl />
      </div>
    </div>
  </Panel>
</template>

<script>
import { translate } from '@/mixins/translate';
import Panel from '@/components/atoms/Panel';
import Subheader from '@/components/atoms/Subheader';
import TournamentTitleSetting from '@/views/tournaments/management/singleTournament/components/SettingsTitle';
import TournamentDescriptionSetting from '@/views/tournaments/management/singleTournament/components/SettingsDescription';
import TournamentCoverSetting from '@/views/tournaments/management/singleTournament/components/SettingsCover';
import TournamentSettingPortraitCover from '@/views/tournaments/management/singleTournament/components/SettingsPortraitCover';
import TournamentSettingStreamUrl from '@/views/tournaments/management/singleTournament/components/SettingsStreamUrl';
import TournamentSettingVanityId from '@/views/tournaments/management/singleTournament/components/SettingsVanityId';
export default {
  name: 'AppearanceSection',
  components: {
    Panel,
    Subheader,
    TournamentTitleSetting,
    TournamentDescriptionSetting,
    TournamentCoverSetting,
    TournamentSettingPortraitCover,
    TournamentSettingStreamUrl,
    TournamentSettingVanityId,
  },
  mixins: [translate('_web_tournament_settings')],
};
</script>
<style lang="scss">
.panel-appearance-panel {
  padding-top: 20px !important;
}

.tournament-info-wrapper__title span {
  font-size: $hr-heading-5 !important;
}

.tournament-name :nth-child(1) {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-name input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.tournament-name :nth-child(2) :focus {
  border: 2px solid $hr-bg-accent;
  border-radius: 5px;
}

.vanity-name :nth-child(2) div {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
  border-radius: 5px;
}

.vanity-name :nth-child(2) span {
  padding-left: 12px;
  color: $hr-text-muted;
}

.vanity-name :nth-child(2) input {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.vanity-name :nth-child(2) div {
  margin-bottom: 40px;
}

.vanity-name :nth-child(2) :focus {
  border: 2px solid $hr-bg-accent;
}

.tournament-description textarea {
  background-color: $hr-bg-header;
  border: 2px solid transparent;
}

.tournament-description textarea ::placeholder {
  color: $hr-text-secondary !important;
}

.tournament-description textarea :focus {
  border: 2px solid $hr-bg-accent;
}

.tournament-description :nth-child(1) {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-stream input {
  background-color: $hr-bg-header;
  width: 154% !important;
  margin-bottom: 10px !important;
  border: 2px solid transparent;
}

.tournament-stream :nth-child(1) {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-stream input :focus {
  border: 2px solid $hr-bg-accent;
}

.tournament-cover label {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}

.tournament-portrait label {
  padding-bottom: 10px;
  font-size: $hr-text-small !important;
  font-weight: 600;
}
</style>
